import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import { SearchBar } from '../';
import { fetchClientsWithFilters } from 'api';
import * as Actions from 'actions';

const debounce_time = 250;

class HeaderSearchBar extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			select_value: '',
			selected_client: '',
			fetching_clients: false,
			show_results: false,
			current_timeout_id: '',
		};

		this.fetchClients = this.fetchClients.bind(this);
		this.handleSelect = this.handleSelect.bind(this);

		this.mounted = false;
		this.search_timer_id = null;
	}

	fetchClients(value) {
		this.setState({ select_value : value });


		return /[A-Za-z]/.test(value) ? new Promise((res, rej) => {
			if(this.search_timer_id) {
				clearTimeout(this.search_timer_id);
			}

			this.search_timer_id = setTimeout(() => {
				this.search_timer_id = null;
				this.setState({ fetching_clients: true });

				const fetch_opts = {
					filters: [
						{ type: 'name', value }
					],
					size: 20
				};
				fetchClientsWithFilters(fetch_opts)
				.then(({ results }) => {
					res({ options: results.map(c => ({ value: c._id, label: c.name || c.email || '(no name)' })) });
				})
				.catch(e => {
					rej(e);
					console.log(e);
					this.props.notify({ message : e.message || e });
				})
				.finally(() => this.mounted ? this.setState({ fetching_clients: false }) : null);
			}, debounce_time);
		}) : Promise.resolve();
	}
	handleSelect(item) {
		if(!item) {
			this.setState({ selected_client: null });
		}
		else {
			this.props.push(`/client/${item.value}`);
		}
	}
	componentDidMount() {
		this.mounted = true;
	}
	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		return (
			<div>
				<Select.Async
					loadOptions={this.fetchClients}
					isLoading={this.state.fetching_clients}
					onChange={this.handleSelect}
					value={this.state.selected_client}
					placeholder='Search Clients'
				/>
			</div>
		);
	}
}

export default connect(null, Actions)(HeaderSearchBar)



// WEBPACK FOOTER //
// ./src/browser/components/header/headerSearchBar.js